import {ProfileInfoBase} from '../../components/formsBase/profileBase';

/**
 * React functional component representing the Profile Base.
 * @component
 * @param {Object} props - The component's properties.
 * @param {React.ReactNode} props.children - The child elements to be rendered within the component.
 * @returns {JSX.Element} The rendered ProfileBase component.
 */
export const ProfileBase = ({children, ...props}) => {
  return <ProfileInfoBase {...props}>{children}</ProfileInfoBase>;
};
